
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_cn from './zh_cn'
import zh_hk from './zh_hk'

//获取浏览器语言
function getNavLanguage() {
  if (navigator.appName == "Netscape") {
    var navLanguage = navigator.language;
    return navLanguage.substr(0, 2);
  }
  return false;
}

/**
 * cookie操作
 */
function getCookie(name, value, options) {
  if (typeof value != 'undefined') { // name and value given, set cookie
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    var expires = '';
    if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
      var date;
      if (typeof options.expires == 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    var path = options.path ? '; path=' + options.path : '';
    var domain = options.domain ? '; domain=' + options.domain : '';
    var s = [cookie, expires, path, domain, secure].join('');
    var secure = options.secure ? '; secure' : '';
    var c = [name, '=', encodeURIComponent(value)].join('');
    var cookie = [c, expires, path, domain, secure].join('')
    document.cookie = cookie;
  } else { // only name given, get cookie
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = jQuery.trim(cookies[i]);
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
};


//确定语言
function getLanguage(){
  let i18nLanguage = 'zh_cn';
  
  if (getCookie("language")) {
    i18nLanguage = getCookie("language");
  } else{
    // 香港深度假期定制的繁体，目前仅登录改系统显示繁体 
    var hostname = window.location.hostname
    if (hostname == 'dev.4.tontisa.cn' || hostname == 'dev.pzy4.tontisa.cn' || hostname == '2758.op110.com.cn' || hostname == 'go-flyholiday.com' || hostname == 'www.go-flyholiday.com'){
      i18nLanguage = 'zh_hk';
    }else{
      // 获取浏览器语言
      var navLanguage = (getNavLanguage() || '').toLowerCase();
      if (navLanguage) {
        // 判断是否在网站支持语言数组里
        var charSize = $.inArray(navLanguage,  ['zh_cn', 'zh_hk', 'en_us']);
        if (charSize > -1) {
          i18nLanguage = navLanguage;
        } 
      } 
    }
    // 存到缓存中
    getCookie("language", i18nLanguage);
  }
  return i18nLanguage.toLocaleLowerCase();
}

//全局注册国际化包
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getLanguage() || 'zh_cn',  //getLanguage() || 
  messages:{
      "zh_cn": zh_cn,
      "zh_hk": zh_hk
  },
  silentTranslationWarn: true//解决警告问题
})
export default i18n


// WEBPACK FOOTER //
// ./src/assets/js/i18n/language.js